export default {
  getPausas: state => state.pausas,
  getPausa: state => state.pausa,
}
